/**
 * Mobile filter "show more" lists: a slim custom scrollbar.
 *
 * Carried over from the 1 Oct 2026 manual theme export, where it was an inline
 * <script> at the end of layout/theme.liquid that ran on every page. Same
 * behaviour, two changes:
 *   - layout/theme.liquid only loads this file on collection and search pages,
 *     the only templates that render the facets;
 *   - the page-wide MutationObserver is debounced, so a burst of DOM changes
 *     (AJAX filter re-render, lazy images) costs one pass instead of one per
 *     mutation.
 *
 * Styles: assets/component-filter.css (.custom-facets-scrollbar*), mobile only.
 * The native scrollbar is hidden there; this draws a 3px track + thumb beside
 * each scrollable `.filter-display-show-more .show-more .facets__list`.
 */
(function ($) {
  'use strict';

  if (!$) return;

  var LIST = '.filter-display-show-more .show-more .facets__list';

  function updateScrollbar(list) {
    var $wrapper = $(list).parent();
    var $scrollbar = $wrapper.find('.custom-facets-scrollbar');
    var $thumb = $wrapper.find('.custom-facets-scrollbar-thumb');

    if (!$scrollbar.length || !$thumb.length) return;

    var scrollHeight = list.scrollHeight;
    var clientHeight = list.clientHeight;
    var scrollTop = list.scrollTop;

    if (scrollHeight <= clientHeight + 1) {
      $scrollbar.hide();
      return;
    }

    $scrollbar.show();

    var trackHeight = clientHeight;
    var thumbHeight = Math.max(35, (clientHeight / scrollHeight) * trackHeight);
    var maxThumbTop = trackHeight - thumbHeight;
    var thumbTop = maxThumbTop * (scrollTop / (scrollHeight - clientHeight));

    $thumb.css({
      height: thumbHeight + 'px',
      transform: 'translate3d(0, ' + thumbTop + 'px, 0)'
    });
  }

  function initFacetScrollbar() {
    $(LIST).each(function () {
      var list = this;
      var $list = $(list);

      if ($list.data('custom-scrollbar-init')) return;

      var $wrapper = $list.parent();
      $wrapper.css({ position: 'relative' });

      var $scrollbar = $('<div class="custom-facets-scrollbar"></div>');
      var $thumb = $('<div class="custom-facets-scrollbar-thumb"></div>');
      $scrollbar.append($thumb);
      $wrapper.append($scrollbar);

      $list.data('custom-scrollbar-init', true);

      list.addEventListener('scroll', function () {
        updateScrollbar(list);
      }, { passive: true });

      updateScrollbar(list);
    });
  }

  function updateAll() {
    $(LIST).each(function () {
      updateScrollbar(this);
    });
  }

  $(function () {
    initFacetScrollbar();

    // The facets are re-rendered by AJAX when a filter changes, which replaces
    // the lists. Re-attach after the DOM settles; one pass per burst.
    var timer = null;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        initFacetScrollbar();
        updateAll();
      }, 50);
    }).observe(document.body, { childList: true, subtree: true });

    $(window).on('resize orientationchange', updateAll);
  });
})(window.jQuery);
